import { TaskTemplateServiceTemplateQuery } from "../../../graphql-types";
import { TaskTemplateServiceTextModuleProps } from "./TaskTemplateService/TaskTemplateServiceTextModule";
import { pp } from "../../shared/utilities/pretty-print";
import { isFluidObject } from "../../shared/types/fluid-object";

export function selectTaskTemplateServiceTextModuleProps(
  data: TaskTemplateServiceTemplateQuery
): TaskTemplateServiceTextModuleProps {
  const imageFluid = data.taskTemplateServicePage?.textModuleImage?.fluid;
  if (!isFluidObject(imageFluid) && imageFluid != null) {
    // This will result in a build error, so it won't be shown to users.
    // eslint-disable-next-line no-console
    console.log(pp({ data }));
    throw Error(
      "data.taskTemplateServicePage.textModuleImage?.fluid is not a FluidObject or null."
    );
  }

  return {
    textModuleDescription:
      data.taskTemplateServicePage?.textModuleDescription ?? undefined,
    textModuleImage: imageFluid,
    textModuleSectionTitle:
      data.taskTemplateServicePage?.textModuleSectionTitle ?? undefined,
  };
}
